export const FIRST_ELEMENT_KEY = 0;
export const SCOREBOARD_WRAPPER_CLASS = 'scoreboard-wrapper';
